/**
 * Harness-only helpers for seeding Long Form AI state "as if it arrived over the WebSocket"
 * (openspec long-form-ai). The Events-drawer button builds a real `LongFormAiEvent` from the static
 * fixture and hands it to `useLongFormAiStore.receiveNarrativeEvent`, so the store is exercised
 * through the same contract the producer (Data Science, Logic Builder) will use — no live socket involved.
 */

import type { LongFormAiEvent } from "./events";

import { VHDP_PRODUCT_SKU } from "./constants";
import { LONG_FORM_AI_EVENT } from "./events";
import { vhdpNarrative, vhdpVariantNarrative } from "./fixtures";

/** The VHDP offer SKU the harness seeds under — the real live-Verizon SKU, so the seeded narrative
 *  keys the same way the real producer will (and matches the ProductSaleFlow selection gate). */
export const HARNESS_VHDP_SKU = VHDP_PRODUCT_SKU;

/** Build the inbound narrative event the harness's seed button pushes, mirroring the real producer —
 *  the RAW narrative. The store's `receiveNarrativeEvent` applies the guided-browsing filter, so a
 *  producer (harness or real WS) never has to. */
export const buildHarnessNarrativeEvent = (sessionId: string, employeeId: string): LongFormAiEvent => ({
    messageType: LONG_FORM_AI_EVENT,
    sessionId,
    employeeId,
    sku: HARNESS_VHDP_SKU,
    narrative: vhdpNarrative,
});

/** A visibly different second narrative, for exercising the "New script available" banner by hand. */
export const buildHarnessVariantNarrativeEvent = (sessionId: string, employeeId: string): LongFormAiEvent => ({
    messageType: LONG_FORM_AI_EVENT,
    sessionId,
    employeeId,
    sku: HARNESS_VHDP_SKU,
    narrative: vhdpVariantNarrative,
});
